<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  const { t } = useI18n()

  const props = defineProps({
    title: {
      type: String,
      default: false
    },
    text: {
      type: String,
      default: false
    },
    txtSee: {
      type: String,
      required: false,
    },
    txtClose: {
      type: String,
      required: false,
    },
  })

  const txtSeeWithDefault = props.txtSee || t('boardDirectors.see');
  const txtCloseWithDefault = props.txtClose || t('boardDirectors.close');

  const isVisible = ref(false)

  const toggleVisibility = () => { 
    isVisible.value = !isVisible.value
  };

</script>

<template>
  <div class="widgetToggle" :class="{ open: isVisible }">
    <button class="enteteToggle" @click="toggleVisibility()">
      <span class="titleToggle">
        {{ title }}
      </span>
      <span class="closeToggle">
        <span>{{ txtCloseWithDefault }}</span>
        <span class="icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"/></svg>
        </span>
      </span>
      <span class="seeToggle">
        <span>{{ txtSeeWithDefault }}</span>
        <span class="icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"/></svg>
        </span>
      </span>
    </button>
    <div class="contenuToggle" v-html="text"></div>
  </div>
</template>

<style lang="scss">
</style>
